import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatLineModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AgrPageToolbarModule, AgrSummaryCardModule } from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { BarnItemComponent } from './components/barn-item/barn-item.component';
import { BarnOverviewComponent } from './components/barn-overview/barn-overview.component';
import { SettingsNavigationComponent } from './components/settings-navigation/settings-navigation.component';
import { SettingsOverviewComponent } from './components/settings-overview/settings-overview.component';
import { SustainabilityOverviewComponent } from './components/sustainability-overview/sustainability-overview.component';
import { BarnResolver } from './resolvers/barn.resolver';
import { FarmSettingsResolver } from './resolvers/farm-settings.resolver';
import { BarnEffects } from './store/effects/barn.effects';
import { FarmSettingsEffects } from './store/effects/farm-settings.effects';
import * as barnReducer from './store/reducers/barn.reducer';
import * as farmSettingsReducer from './store/reducers/farm-settings.reducer';

@NgModule({
  declarations: [
    SettingsOverviewComponent,
    SettingsNavigationComponent,
    BarnOverviewComponent,
    BarnItemComponent,
    SustainabilityOverviewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatToolbarModule,
    MatTabsModule,
    AgrFormModule,
    AgrDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    AgrPageToolbarModule,
    MatIconModule,
    MatLineModule,
    MatListModule,
    MatDividerModule,
    MatSlideToggleModule,
    AgrSummaryCardModule,
    RouterModule,
  ],
  providers: [
    BarnResolver,
    FarmSettingsResolver,
    provideState('barnModule', barnReducer.reducer),
    provideState('farmSettingsModule', farmSettingsReducer.reducer),
    provideEffects([BarnEffects, FarmSettingsEffects]),
  ],
})
export class SettingsModule {}
